import React from 'react';
import PropTypes from 'prop-types';
import sponsoredProductsPropType from './sponsoredProductsPropType';

function getProductId(product) {
  return product.getId
    ? product.getId()
    : `product${product.getProductId()}`;
}

function removeDuplicateSponsoredProducts(productsView, sponsoredProducts) {
  if (sponsoredProducts.length === 0) {
    return;
  }

  const originalProducts = productsView.getSortedProducts();
  sponsoredProducts.forEach(
    (sponsoredProduct) =>
      originalProducts
        .filter((product) => getProductId(product) === `product${sponsoredProduct.id}`)
        .forEach((item) => item.hide())
  );

  if (productsView.updateProductsHeight) {
    productsView.updateProductsHeight();
  }
}

export default (BaseComponent) => {
  const displayName =
    BaseComponent.displayName || BaseComponent.name || 'Component';

  class withDuplicityProductsRemover extends React.PureComponent {
    componentDidMount() {
      const { productsView, sponsoredProducts } = this.props;
      removeDuplicateSponsoredProducts(productsView, sponsoredProducts);
    }

    render() {
      return <BaseComponent {...this.props} />;
    }
  }

  withDuplicityProductsRemover.displayName =
    `withDuplicityProductsRemover(${displayName})`;

  withDuplicityProductsRemover.propTypes = {
    productsView: PropTypes.shape({
      getSortedProducts: PropTypes.func.isRequired,
      updateProductsHeight: PropTypes.func
    }).isRequired,
    sponsoredProducts: sponsoredProductsPropType.isRequired
  };

  return withDuplicityProductsRemover;
};
